import { createEvent, restore, sample } from 'effector'
import { libraryGridFavoritesTvShowsWidget } from '~/widgets/library/grid/favorites/tvShows'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridFavoritesTvShowsWidget.$isGridFavoritesTvShowsLoading,
  target: setContentLoading,
})
